import router from "@/router"

const initialCount = parseInt(window.localStorage.getItem("header-title-clicked") ?? "0")
export default class CommonHeaderTitle{
  titleClickCallback = [] as Function[]
  
  titleFirstClick = true
  titleClickedCount = initialCount

  breadCrumbUrl:string|null = null
  
  centerDiv = window.document.getElementById("header-center") as HTMLDivElement

  constructor(){
    this.centerDiv.addEventListener("click", (e:Event)=>{
      this.emitTextClick()
      e.preventDefault();
    })
  }

  public setBreadCrumb(url: string){
    if(url){
      window.document.getElementById("header-breadcrumb")!.style.display = "inline-block";
      const link = window.document.getElementById("header-breadcrumb-link") as HTMLAnchorElement
      //初回設定の場合
      if(!this.breadCrumbUrl){
        link.addEventListener("click", (e:Event)=>{
          router.push(this.breadCrumbUrl!);
          e.preventDefault();
        })
      }
      const firstFolder = url.split("/")[1]
      this.breadCrumbUrl = "/" + firstFolder;
      link.innerHTML = firstFolder;
      link.href = this.breadCrumbUrl;
    }else{
      window.document.getElementById("header-breadcrumb")!.style.display = "none";
    }
  }

  public setTitleText(redText:string,text:string){
    this.centerDiv.style.display = "initial"
    window.document.getElementById("header-center-text")!.innerHTML = text;
    window.document.getElementById("header-center-text-nortice")!.innerHTML = redText;
  }
  
  public addTitleClickListener(f:Function){
      this.titleClickCallback.push(f)
  }

  emitTextClick(data?:any){
    if(this.titleFirstClick){
      this.titleFirstClick = false
      ++this.titleClickedCount;
      window.localStorage.setItem("header-title-clicked", this.titleClickedCount.toString());
    }
    this.titleClickCallback.forEach(f => f(data))
  }

  public clearTitle(){
      this.titleClickCallback = []
      this.titleFirstClick = true
      this.centerDiv.style.display = "none"
  }
  
}